export default __webpack_public_path__ + "images/0x50c42deacd8fc9773493ed674b675be577f2634b.png";